module.exports = __webpack_public_path__ + "img/gem.f83287c5.png";